var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.16655 1.1662H3.50035C3.19096 1.1662 2.89425 1.28913 2.67547 1.50794C2.4567 1.72675 2.3338 2.02352 2.3338 2.33296V11.667C2.3338 11.9765 2.4567 12.2733 2.67547 12.4921C2.89425 12.7109 3.19096 12.8338 3.50035 12.8338H10.4996C10.809 12.8338 11.1058 12.7109 11.3245 12.4921C11.5433 12.2733 11.6662 11.9765 11.6662 11.667V4.66648M8.16655 1.1662C8.35119 1.1659 8.53406 1.20214 8.70464 1.27283C8.87521 1.34351 9.03013 1.44725 9.16045 1.57807L11.2532 3.67124C11.3844 3.80162 11.4884 3.95671 11.5593 4.12753C11.6302 4.29836 11.6665 4.48153 11.6662 4.66648M8.16655 1.1662V4.0831C8.16655 4.23782 8.228 4.38621 8.33739 4.49561C8.44677 4.60502 8.59513 4.66648 8.74982 4.66648L11.6662 4.66648M5.83345 5.24986H4.6669M9.3331 7.58338H4.6669M9.3331 9.9169H4.6669",
    stroke: "#60A5FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeSquare);
export default __webpack_public_path__ + "static/media/code-square.7708282716c82a0baee6d29dda8f98c2.svg";
export { ForwardRef as ReactComponent };